import React from 'react';

import { Button } from 'antd';
import styled from 'styled-components';

import Notification from 'components/Notification/Notification';

import UserManagementTable from './table/UserManagementTable';
import { useUserManagementContext } from './UserManagementContext';
import UserManagementControls from './UserManagementControls';
import UserManagementFeatureFlagsModal from './UserManagementFeatureFlagsModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 10px 30px;
`;

const UserManagementData = () => {
  const { selectedUserIds, selectedUsers, clearSelection, refetch } = useUserManagementContext();
  const [featureFlagsModalOpen, setFeatureFlagsModalOpen] = React.useState(false);

  const handleBulkSave = () => {
    refetch();
    clearSelection();
  };

  return (
    <Container>
      <Notification
        totalCount={0}
        selectedCount={selectedUserIds.length}
        singularLabel={'user'}
        multipleLabel={'users'}
        onClose={clearSelection}
        actions={
          <Button
            type="primary"
            style={{
              color: 'var(--white)',
              backgroundColor: 'var(--button-blue)',
            }}
            onClick={() => setFeatureFlagsModalOpen(true)}
            data-test-id="user-management-bulk-feature-flags"
          >
            Edit Multiple
          </Button>
        }
      />
      {featureFlagsModalOpen && (
        <UserManagementFeatureFlagsModal
          open={featureFlagsModalOpen}
          onClose={() => setFeatureFlagsModalOpen(false)}
          users={selectedUsers}
          onSaved={handleBulkSave}
        />
      )}
      <UserManagementControls />
      <UserManagementTable />
    </Container>
  );
};

export default UserManagementData;
